const cache = new Map<string, string>();

/**
 * Ritorna il testo senza tag HTML (entità decodificate), per la sola
 * visualizzazione. Usa `DOMParser`: SOLO browser. Lato server (idratazione,
 * Node) usare `cachedStripHtml` (string-strip-html).
 *
 * Usato in `convertColumnValue` (import CSV, lato admin). NB: normalizza
 * spazi/entità diversamente da `cachedStripHtml` — qui i blocchi si concatenano
 * (`Prima<br>Seconda` → `PrimaSeconda`), là diventano spazio.
 */
export function stripHtmlForDisplay(html: string): string {
  const cached = cache.get(html);
  if (cached !== undefined) return cached;
  const result =
    new DOMParser().parseFromString(html, 'text/html').body.textContent || '';
  cache.set(html, result);
  return result;
}

export function clearStripHtmlForDisplayCache(): void {
  cache.clear();
}
